/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_step1_description = /** @type {(inputs: {}) => string} */ () => {
	return `Cuéntanos un poco sobre ti para personalizar tu experiencia.`
};

const en_onboarding_step1_description = /** @type {(inputs: {}) => string} */ () => {
	return `Tell us a bit about yourself so we can personalize your experience.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_step1_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_step1_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_step1_description", locale)
	if (locale === "es") return es_onboarding_step1_description(inputs)
	return en_onboarding_step1_description(inputs)
};
export { onboarding_step1_description as "onboarding.step1.description" }